//Import External Components
import React, { useEffect, useRef, useState } from 'react';
import { View, TouchableOpacity, FlatList, ScrollView, ActivityIndicator, Image } from 'react-native';
import { Text } from '../../globalComponents/NativeOverrides';

//Import Internal Components
import Colors from '../../constants/Colorsv2';
import BENotification from './components/BENotification';

//Import actions
import { connect } from 'react-redux';

//Import Types
import { NotificationsScreenProps } from '../../types';
import moment from 'moment';
import { getPlayerNotificationsByPlayerId, markNotificationsAsRead, updatePlayerNotification } from '../../store/actionsv1/player';
import { PlayerNotificationProps } from '../../store/types/auth_svc';

function NotificationsScreen({ navigation, player_notifications, player_id, updatePlayerNotification, getPlayerNotificationsByPlayerId, markNotificationsAsRead }: NotificationsScreenProps){
    const [ loading, setLoading ] = useState(false)
    const [ activeTab, setActiveTab ] = useState('all')
    const [ isScrollAtEnd, setIsScrollAtEnd ] = useState(false)
    const [ notifyOffset, setNotifyOffset ] = useState(0)
    const notifyScrollRef = useRef()

    

    useEffect(() => {
        setLoading(true)
        getNotificationsByPlayerIdFromServer(player_id, getNotifyTypeFromTab(), 0)
    }, [activeTab])

    useEffect(() => {
        if(isScrollAtEnd && !loading){ 
            setLoading(true)
            getNotificationsByPlayerIdFromServer(player_id, getNotifyTypeFromTab())
         }
    },[isScrollAtEnd])

    const getNotificationsByPlayerIdFromServer = async(player_id:string, notification_type?:string, offsetOverride?:number) => {
        let offset = offsetOverride ?? notifyOffset + 1
        setLoading(true)
        await getPlayerNotificationsByPlayerId(player_id, notification_type, offset)
        setLoading(false)
    }

    const getNotifyTypeFromTab = () => {
        let notification_type:string|undefined
        switch(activeTab){
            case 'all': break;
            case 'markets': notification_type = 'order_notifications'; break;
            case 'competitions': notification_type = 'competition_notifications'; break;
            case 'social': notification_type = 'social_notifications'; break;
            default: break
        }
        return notification_type
    }

    const loadMoreIfNeeded = ({ layoutMeasurement, contentOffset, contentSize }:any) => {
        if(loading){ return }
        const paddingToBottom = 100
        const needMore = layoutMeasurement.height + contentOffset.y >= contentSize.height - paddingToBottom
        if(needMore){ setIsScrollAtEnd(true) } else { setIsScrollAtEnd(false) }
    }

    const renderNotifications = ({ item }) => {
        return (
            <BENotification notification={item} navigation={navigation} onRemove={(pn) => updatePlayerNotification({ ...pn, status:'read' })}/>
        )
    }

    const handleRemoveAll = async() => {
        setLoading(true)
        await markNotificationsAsRead(getNotifyTypeFromTab())
        setLoading(false)
    }
   
    return (
        <View style={{flex:1, backgroundColor:Colors.shades.white}}>
            <ScrollView ref={notifyScrollRef} onScroll={({ nativeEvent }) => {
                loadMoreIfNeeded(nativeEvent)
            }}
            scrollEventThrottle={400}>
                <View style={{flexDirection:'row', marginBottom:5, alignItems:'center', paddingLeft:10, paddingRight:10, backgroundColor:Colors.shades.white}}>
                    <TouchableOpacity style={[activeTab==='all'?localStyles.activeSocialToggle:localStyles.inactiveSocialToggle, { flex:1 }]} onPress={() => setActiveTab('all')}>
                        <Text textAlign='center' size={14} color={activeTab==='all'?Colors.brand.midnight:Colors.brand.slate} weight={activeTab==='all'?'semibold':'regular'}>All</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[activeTab==='social'?localStyles.activeSocialToggle:localStyles.inactiveSocialToggle, { flex:1 }]} onPress={() => setActiveTab('social')}>
                        <Text textAlign='center' size={14} color={activeTab==='social'?Colors.brand.midnight:Colors.brand.slate} weight={activeTab==='social'?'semibold':'regular'}>Social</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[activeTab==='markets'?localStyles.activeSocialToggle:localStyles.inactiveSocialToggle, { flex:1 }]} onPress={() => setActiveTab('markets')}>
                        <Text textAlign='center' size={14} color={activeTab==='markets'?Colors.brand.midnight:Colors.brand.slate} weight={activeTab==='markets'?'semibold':'regular'}>Markets</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={[activeTab==='competitions'?localStyles.activeSocialToggle:localStyles.inactiveSocialToggle, { flex:1 }]} onPress={() => setActiveTab('competitions')}>
                        <Text textAlign='center' size={14} color={activeTab==='competitions'?Colors.brand.midnight:Colors.brand.slate} weight={activeTab==='competitions'?'semibold':'regular'}>Comps</Text>
                    </TouchableOpacity>
                </View>
                <View>
                {!loading && player_notifications.length === 0?
                    <View style={{justifyContent:'center', alignItems:'center', padding:20}}>
                        <Image
                            source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1698862064/open_box_nryphw.png' }}
                            style={{ width: 200, height: 200 }}
                            resizeMode='contain'
                        />
                        <Text style={{fontSize:12, fontFamily:'roboto-regular'}}>You are all up to date!</Text>
                    </View>
                    :
                    <></> 
                    }
                    <FlatList data={player_notifications.filter(pn => pn.status === 'unread').sort((a,b) => moment(b.create_datetime) - moment(a.create_datetime))} renderItem={renderNotifications} keyExtractor={(item, index) => item.player_notification_id.toString()} />
                </View>
                {loading ?
                    <View style={{justifyContent:'center', alignItems:'center', padding:20}}>
                        <ActivityIndicator size='large' color={Colors.brand.midnight} />
                    </View>
                :<></>}
            </ScrollView>
            {player_notifications.length>0?
            <TouchableOpacity style={localStyles.clearAllStyle} onPress={() => handleRemoveAll()}>
                <Text size={14} color={Colors.brand.electric} textAlign='center' weight='semibold'>Clear {activeTab==='all'?`notifications`:`${activeTab} notifications`}</Text>
            </TouchableOpacity>
            :<View style={{flex:1/4}} />}
        </View>
        

    )
}

const localStyles = {
    activeSocialToggle: { paddingTop:10, paddingBottom:10, paddingRight:6, paddingLeft:6, backgroundColor:Colors.shades.shade100, borderBottomWidth:2, borderBottomColor:Colors.brand.cyan },
    inactiveSocialToggle: { paddingTop:10, paddingBottom:10, paddingRight:6, paddingLeft:6 },
    clearAllStyle: {
        padding:15,
        shadowRadius: 2,
        shadowOffset: {
          width: 0,
          height: -4,
        },
        shadowColor: 'rgba(0, 0, 0, 0.12)',
        elevation: 4,
      }
}

const mapStateToProps = (state:any) => {
    return {
        player_id: state.player.player?.player_id,
        player_notifications: state.player.player_notifications
    }
}

const mapDispatchToProps = (dispatch:any) => {
    return {
        getPlayerNotificationsByPlayerId: (player_id:string, notification_type:string, offset:number) => dispatch(getPlayerNotificationsByPlayerId(player_id, notification_type, offset)),
        markNotificationsAsRead: (notification_type?:string) => dispatch(markNotificationsAsRead(notification_type)),
        updatePlayerNotification: (pn:PlayerNotificationProps) => dispatch(updatePlayerNotification(pn))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsScreen)

